import { ensureOrgDepartments } from "../../../../../services/useOrgData";
import React from "react";
import OrgNamedList from "./OrgNamedList";
import { createDepartment, deleteDepartment } from "../../../../../services/department";
import { getActiveLegalUnitId } from "../../../../../services/globalData";

const Departments = () => (
  <OrgNamedList
    title="Departments"
    singular="Department"
    addLabel="Add Department"
    emptyText="Create departments to organise your people."
    fetchItems={async () => {
      return (await ensureOrgDepartments()) || [];
    }}
    createItem={(name) =>
      createDepartment({ name, legalUnit: getActiveLegalUnitId() })
    }
    removeItem={(item) => deleteDepartment(item._id)}
  />
);

export default Departments;
